var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ACTIVATE_MODEL_SIZE from 'api/mutations/ACTIVATE_MODEL_SIZE';
import ADD_MODEL_COLOR from 'api/mutations/ADD_MODEL_COLOR';
import CHANGE_MODEL_SIZE_STANDARD from 'api/mutations/CHANGE_MODEL_SIZE_STANDARD';
import DEACTIVATE_MODEL_SIZE from 'api/mutations/DEACTIVATE_MODEL_SIZE';
import REMOVE_MODEL_COLORS from 'api/mutations/REMOVE_MODEL_COLORS';
import UPDATE_MODEL_COLOR from 'api/mutations/UPDATE_MODEL_COLOR';
import UPDATE_MODEL_SPECIFICATION_VARIANTS from 'api/mutations/UPDATE_MODEL_SPECIFICATION_VARIANTS';
import GET_CURRENT_TENANT_SIZINGS from 'api/queries/GET_CURRENT_TENANT_SIZINGS';
import GET_MODEL_SPECIFICATION from 'api/queries/GET_MODEL_SPECIFICATION';
import client from '../api/environment';
const initialState = {
    item: null,
    sizings: {
        items: [],
        status: 'idle',
        error: null,
    },
    status: {
        fetch: 'idle',
        addColor: 'idle',
        editColor: 'idle',
        removeColor: 'idle',
    },
    errors: {
        fetch: null,
        addColor: null,
        editColor: null,
        removeColor: null,
    },
    refetchFlags: {
        fetch: false,
        addColor: false,
        editColor: false,
        removeColor: false,
    },
};
export const fetchSizings = createAsyncThunk('specificationDetails/fetchSizings', () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield client.query({
        query: GET_CURRENT_TENANT_SIZINGS,
        variables: { first: 25, after: '' },
    });
    return response.data.me.currentTenant.sizeStandards.edges.map((item) => item.node);
}));
export const fetchSpecificationProductionQuantities = createAsyncThunk('specificationProductionQuantities/fetchSpecificationProductionQuantities', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ specificationId }, { rejectWithValue }) {
    try {
        const specifiactionData = yield client.query({
            query: GET_MODEL_SPECIFICATION,
            variables: { modelSpecificationId: specificationId },
            fetchPolicy: 'network-only',
        });
        return {
            sizeStandard: specifiactionData.data.node.sizeStandard,
            sizes: specifiactionData.data.node.sizes.edges.map((item) => item.node),
            colors: specifiactionData.data.node.colors.edges.map((item) => item.node),
            variants: specifiactionData.data.node.variants.edges.map((item) => item.node),
        };
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const changeSizeStandard = createAsyncThunk('specificationProductionQuantities/changeSizeStandard', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ specificationId, sizeStandardId }, { rejectWithValue }) {
    try {
        const sizeStandard = yield client.mutate({
            mutation: CHANGE_MODEL_SIZE_STANDARD,
            variables: { modelSpecificationId: specificationId, sizeStandardId },
        });
        return sizeStandard.data.changeModelSpecificationSizeStandard.modelSpecification.sizeStandard;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const activateSize = createAsyncThunk('specificationProductionQuantities/activateSize', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ specificationSizeId }, { rejectWithValue }) {
    try {
        const modelSize = yield client.mutate({
            mutation: ACTIVATE_MODEL_SIZE,
            variables: { modelSpecificationSizeId: specificationSizeId },
        });
        return modelSize.data.activateModelSpecificationSize.modelSpecificationSize;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const deactivateSize = createAsyncThunk('specificationProductionQuantities/deactivateSize', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ specificationSizeId }, { rejectWithValue }) {
    try {
        const modelSize = yield client.mutate({
            mutation: DEACTIVATE_MODEL_SIZE,
            variables: { modelSpecificationSizeId: specificationSizeId },
        });
        return modelSize.data.deactivateModelSpecificationSize.modelSpecificationSize;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const addModelColor = createAsyncThunk('specificationProductionQuantities/addModelColor', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ specificationId, colorName }, { rejectWithValue }) {
    try {
        const modelColor = yield client.mutate({
            mutation: ADD_MODEL_COLOR,
            variables: { modelSpecificationId: specificationId, colorName },
        });
        return modelColor.data.addModelSpecificationColor.modelSpecificationColor;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const editModelColor = createAsyncThunk('specificationProductionQuantities/editModelColor', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ specificationId, colorId, colorName, }, { rejectWithValue }) {
    try {
        if (!specificationId) {
            throw new Error('Missing specificationId');
        }
        yield client.mutate({
            mutation: UPDATE_MODEL_COLOR,
            variables: { modelSpecificationColorId: colorId, colorName },
        });
        return { id: colorId, name: colorName };
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const updateModelVariants = createAsyncThunk('specificationProductionQuantities/updateModelVariants', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ variantId, value }, { rejectWithValue }) {
    var _c, _d;
    try {
        const modelColor = yield client.mutate({
            mutation: UPDATE_MODEL_SPECIFICATION_VARIANTS,
            variables: {
                variantsQuantity: [[variantId, value]],
            },
        });
        return {
            variantId,
            value,
            response: (_d = (_c = modelColor.data) === null || _c === void 0 ? void 0 : _c.addModelSpecificationColor) === null || _d === void 0 ? void 0 : _d.modelSpecificationColor,
        };
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const removeModelVariants = createAsyncThunk('specificationProductionQuantities/removeModelVariants', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ colorIds }, { rejectWithValue }) {
    var _c, _d, _e;
    try {
        yield client.mutate({
            mutation: REMOVE_MODEL_COLORS,
            variables: { modelSpecificationColorIds: colorIds },
        });
        return colorIds;
    }
    catch (error) {
        const apolloError = error;
        const exceptionMessage = (_e = (_d = (_c = apolloError.graphQLErrors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.extensions) === null || _e === void 0 ? void 0 : _e.exceptionMessage;
        return rejectWithValue(exceptionMessage || apolloError.message);
    }
}));
const specificationProductionQuantitiesSlice = createSlice({
    name: 'specificationProductionQuantities',
    initialState,
    reducers: {
        resetSpecificationProductionQuantities(state) {
            state.item = null;
            state.status.fetch = 'idle';
            state.errors.fetch = null;
            state.refetchFlags.fetch = false;
        },
        updateStoreModelVariants: (state, action) => {
            const { variantId, value } = action.payload;
            const itemIndex = state.item.variants.findIndex((item) => item.id === variantId);
            if (itemIndex !== -1) {
                state.item.variants[itemIndex] = Object.assign(Object.assign({}, state.item.variants[itemIndex]), { quantity: value });
            }
        },
    },
    extraReducers: (builder) => {
        builder
            // fetchSpecificationProductionQuantities
            .addCase(fetchSpecificationProductionQuantities.pending, (state) => {
            state.status.fetch = 'loading';
        })
            .addCase(fetchSpecificationProductionQuantities.fulfilled, (state, action) => {
            state.status.fetch = 'succeeded';
            state.refetchFlags.fetch = false;
            state.item = action.payload;
        })
            .addCase(fetchSpecificationProductionQuantities.rejected, (state, action) => {
            state.status.fetch = 'failed';
            state.refetchFlags.fetch = false;
            state.errors.fetch =
                action.payload || 'Failed to fetch specification production quantities';
        })
            // SIZES
            // fetchSizings
            .addCase(fetchSizings.pending, (state) => {
            state.sizings.status = 'loading';
        })
            .addCase(fetchSizings.fulfilled, (state, action) => {
            state.sizings.items = action.payload;
            state.sizings.status = 'succeeded';
        })
            .addCase(fetchSizings.rejected, (state, action) => {
            state.sizings.status = 'failed';
            state.sizings.error = action.error.message || 'Failed to fetch sizings';
        })
            // changeSizeStandard
            .addCase(changeSizeStandard.pending, () => { })
            .addCase(changeSizeStandard.fulfilled, (state, action) => {
            state.item.sizeStandard = action.payload;
            state.refetchFlags.fetch = true;
        })
            .addCase(changeSizeStandard.rejected, (state, action) => {
            state.errors.other =
                action.payload || 'Failed to change size in production quantities';
        })
            // activateSize
            .addCase(activateSize.pending, () => { })
            .addCase(activateSize.fulfilled, (state) => {
            state.refetchFlags.fetch = true;
        })
            .addCase(activateSize.rejected, (state, action) => {
            state.errors.other =
                action.payload || 'Failed to activate size in production quantities';
        })
            // deactivateSize
            .addCase(deactivateSize.pending, () => { })
            .addCase(deactivateSize.fulfilled, (state) => {
            state.refetchFlags.fetch = true;
        })
            .addCase(deactivateSize.rejected, (state, action) => {
            state.errors.other =
                action.payload || 'Failed to deactivate size in production quantities';
        })
            // COLORS & VARIANTS
            // addModelColor
            .addCase(updateModelVariants.pending, () => { })
            .addCase(updateModelVariants.fulfilled, () => { })
            .addCase(updateModelVariants.rejected, (state, action) => {
            state.errors.other =
                action.payload || 'Failed to update model variants in production quantities';
        })
            .addCase(addModelColor.pending, (state) => {
            state.status.addColor = 'loading';
        })
            .addCase(addModelColor.fulfilled, (state) => {
            state.status.addColor = 'succeeded';
        })
            .addCase(addModelColor.rejected, (state, action) => {
            state.status.addColor = 'failed';
            state.errors.other =
                action.payload || 'Failed to add model color in production quantities';
        })
            .addCase(editModelColor.pending, (state) => {
            state.status.editColor = 'loading';
        })
            .addCase(editModelColor.fulfilled, (state, action) => {
            state.status.editColor = 'succeeded';
            state.item.colors = state.item.colors.map((color) => color.id === action.payload.id ? Object.assign(Object.assign({}, color), { name: action.payload.name }) : color);
        })
            .addCase(editModelColor.rejected, (state, action) => {
            state.status.editColor = 'failed';
            state.errors.other =
                action.payload || 'Failed to edit model color in production quantities';
        })
            .addCase(removeModelVariants.pending, (state) => {
            state.status.removeColor = 'loading';
        })
            .addCase(removeModelVariants.fulfilled, (state, action) => {
            state.status.removeColor = 'succeeded';
            const removedIds = action.payload;
            state.item.colors = state.item.colors.filter((color) => !removedIds.includes(color.id));
            state.item.variants = state.item.variants.filter((variant) => !removedIds.includes(variant.color.id));
        })
            .addCase(removeModelVariants.rejected, (state, action) => {
            state.status.removeColor = 'failed';
            state.errors.other =
                action.payload || 'Failed to remove model vairant in production quantities';
        });
    },
});
export const { resetSpecificationProductionQuantities, updateStoreModelVariants } = specificationProductionQuantitiesSlice.actions;
export const selectProductionQuantitiesStatus = (state) => state.specificationProductionQuantities.status;
export const selectProductionQuantitiesErrors = (state) => state.specificationProductionQuantities.errors;
export const selectProductionQuantitiesRefetchFlags = (state) => state.specificationProductionQuantities.refetchFlags;
export const selectProductionQuantitiesItem = (state) => state.specificationProductionQuantities.item;
export default specificationProductionQuantitiesSlice.reducer;
